var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ubruCoffeeView"},[_c('ubruCoffee')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }